import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { axiosInstance } from "../../../../api/axiosInstance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { GetAllDiarioObrasRequest, GetAllDiarioObrasResponse } from "../daos/read/get_all_diario_obras";
import { AxiosError } from "axios";
import { IDiarioObraService } from "./diario_obra_service";
import { DeleteDiarioObraRequest, DeleteDiarioObraResponse } from "../daos/delete/delete_diario_obras";
import { CreateDiarioObrasRequest, CreateDiarioObrasResponse } from "../daos/create/create_diario_obra";
import { CreateDiarioObrasEfetivoRequest, CreateDiarioObrasEfetivoResponse } from "../daos/create/create_diario_obra_efetivo";
import { UpdateDiarioObrasEfetivoRequest, UpdateDiarioObrasEfetivoResponse } from "../daos/update/update_diario_obra_efetivo";
import { DeleteDiarioObraEfetivoRequest, DeleteDiarioObraEfetivoResponse } from "../daos/delete/delete_diario_obras_efetivo";
import { GetAllDiarioObrasEfetivoRequest, GetAllDiarioObrasEfetivoResponse } from "../daos/read/get_all_diario_obras_efetivo";
import { GetAllDiarioObrasEquipamentoRequest, GetAllDiarioObrasEquipamentoResponse } from "../daos/read/get_all_diario_obras_equipamento";
import { DeleteDiarioObraEquipamentoRequest, DeleteDiarioObraEquipamentoResponse } from "../daos/delete/delete_diario_obras_equipamento";
import { CreateDiarioObrasEquipamentoRequest, CreateDiarioObrasEquipamentoResponse } from "../daos/create/create_diario_obra_equipamento";
import { UpdateDiarioObrasEquipamentoRequest, UpdateDiarioObrasEquipamentoResponse } from "../daos/update/update_diario_obra_equipamento";
import { GetAllDiarioObrasAtividadesRequest, GetAllDiarioObrasAtividadesResponse } from "../daos/read/get_all_diario_obras_atividades";
import { CreateDiarioObrasAtividadesRequest, CreateDiarioObrasAtividadesResponse } from "../daos/create/create_diario_obra_atividades";
import { UpdateDiarioObrasAtividadesRequest, UpdateDiarioObrasAtividadesResponse } from "../daos/update/update_diario_obra_atividades";
import { DeleteDiarioObraAtividadesRequest, DeleteDiarioObraAtividadesResponse } from "../daos/delete/delete_diario_obras_atividades";
import { GetAllDiarioObrasParalisacoesRequest, GetAllDiarioObrasParalisacoesResponse } from "../daos/read/get_all_diario_obras_paralisacoes";
import { CreateDiarioObrasParalisacoesRequest, CreateDiarioObrasParalisacoesResponse } from "../daos/create/create_diario_obra_paralisacoes";
import { UpdateDiarioObrasParalisacoesRequest, UpdateDiarioObrasParalisacoesResponse } from "../daos/update/update_diario_obra_paralisacoes";
import { DeleteDiarioObraParalisacoesRequest, DeleteDiarioObraParalisacoesResponse } from "../daos/delete/delete_diario_obras_paralisacoes";
import { GetAllDiarioObrasImagensRequest, GetAllDiarioObrasImagensResponse } from "../daos/read/get_all_diario_obras_imagens";
import { CreateDiarioObrasImagensRequest, CreateDiarioObrasImagensResponse } from "../daos/create/create_diario_obra_imagens";
import { UpdateDiarioObrasImagensRequest, UpdateDiarioObrasImagensResponse } from "../daos/update/update_diario_obra_imagens";
import { DeleteDiarioObraImagensRequest, DeleteDiarioObraImagensResponse } from "../daos/delete/delete_diario_obras_imagens";
import { UpdateDiarioObrasRequest, UpdateDiarioObrasResponse } from "../daos/update/update_diario_obra";
import { CopiaDiarioObrasRequest, CopiaDiarioObrasResponse } from "../daos/create/copia_diario_obra";
import { AprovarDiarioObrasRequest, AprovarDiarioObrasResponse } from "../daos/update/aprovar_diario_obra";
import { GetAllDiarioObrasIndicadoresResponse } from "../daos/read/get_all_auditoria_indicadores";
import { DiarioObrasIndicadores } from "../../domain/models/diarioobras_indicadores_lista";
import { DownloadDiarioObraImagensRequest } from "../daos/read/download_diario_obras_imagens";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";



export class DiarioObraService implements IDiarioObraService {

  //#region DiarioObras
  async getAllListagemDiariosObras(request: GetAllDiarioObrasRequest): Promise<GetAllDiarioObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObras/listDiarioObras`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async copiaDiarioObra(request: CopiaDiarioObrasRequest): Promise<CopiaDiarioObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObras/copia`, request);
      const response = handleAxiosResponse<CopiaDiarioObrasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObra(request: CreateDiarioObrasRequest): Promise<CreateDiarioObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObras/create`, request);
      const response = handleAxiosResponse<CreateDiarioObrasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObra(request: DeleteDiarioObraRequest): Promise<DeleteDiarioObraResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObras/delete", { data: request });

      const response = handleAxiosResponse<DeleteDiarioObraResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObra(request: UpdateDiarioObrasRequest): Promise<UpdateDiarioObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObras/update`, request);
      const response = handleAxiosResponse<UpdateDiarioObrasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async aprovarDiarioObra(request: AprovarDiarioObrasRequest): Promise<AprovarDiarioObrasResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObras/aprovar`, request);
      const response = handleAxiosResponse<AprovarDiarioObrasResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Efetivo
  async getAllListagemDiariosObrasEfetivo(request: GetAllDiarioObrasEfetivoRequest): Promise<GetAllDiarioObrasEfetivoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEfetivo/listDiarioObrasEfetivo`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasEfetivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObraEfetivo(request: CreateDiarioObrasEfetivoRequest): Promise<CreateDiarioObrasEfetivoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEfetivo/create`, request);
      const response = handleAxiosResponse<CreateDiarioObrasEfetivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObraEfetivo(request: UpdateDiarioObrasEfetivoRequest): Promise<UpdateDiarioObrasEfetivoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEfetivo/update`, request);
      const response = handleAxiosResponse<UpdateDiarioObrasEfetivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObraEfetivo(request: DeleteDiarioObraEfetivoRequest): Promise<DeleteDiarioObraEfetivoResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObrasEfetivo/delete", { data: request });

      const response = handleAxiosResponse<DeleteDiarioObraEfetivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Equipamento
  async getAllListagemDiariosObrasEquipamento(request: GetAllDiarioObrasEquipamentoRequest): Promise<GetAllDiarioObrasEquipamentoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEquipamento/listDiarioObrasEquipamento`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasEquipamentoResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObraEquipamento(request: CreateDiarioObrasEquipamentoRequest): Promise<CreateDiarioObrasEquipamentoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEquipamento/create`, request);
      const response = handleAxiosResponse<CreateDiarioObrasEquipamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObraEquipamento(request: UpdateDiarioObrasEquipamentoRequest): Promise<UpdateDiarioObrasEquipamentoResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasEquipamento/update`, request);
      const response = handleAxiosResponse<UpdateDiarioObrasEquipamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObraEquipamento(request: DeleteDiarioObraEquipamentoRequest): Promise<DeleteDiarioObraEquipamentoResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObrasEquipamento/delete", { data: request });

      const response = handleAxiosResponse<DeleteDiarioObraEquipamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Atividades
  async getAllListagemDiariosObrasAtividades(request: GetAllDiarioObrasAtividadesRequest): Promise<GetAllDiarioObrasAtividadesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasAtividades/listDiarioObrasAtividades`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasAtividadesResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObraAtividades(request: CreateDiarioObrasAtividadesRequest): Promise<CreateDiarioObrasAtividadesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasAtividades/create`, request);
      const response = handleAxiosResponse<CreateDiarioObrasAtividadesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObraAtividade(request: UpdateDiarioObrasAtividadesRequest): Promise<UpdateDiarioObrasAtividadesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasAtividades/update`, request);
      const response = handleAxiosResponse<UpdateDiarioObrasAtividadesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObraAtividades(request: DeleteDiarioObraAtividadesRequest): Promise<DeleteDiarioObraAtividadesResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObrasAtividades/delete", { data: request });

      const response = handleAxiosResponse<DeleteDiarioObraAtividadesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Paralisacoes
  async getAllListagemDiariosObrasParalisacoes(request: GetAllDiarioObrasParalisacoesRequest): Promise<GetAllDiarioObrasParalisacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasParalisacoes/listDiarioObrasParalisacoes`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasParalisacoesResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObraParalisacoes(request: CreateDiarioObrasParalisacoesRequest): Promise<CreateDiarioObrasParalisacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasParalisacoes/create`, request);
      const response = handleAxiosResponse<CreateDiarioObrasParalisacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObraParalisacoes(request: UpdateDiarioObrasParalisacoesRequest): Promise<UpdateDiarioObrasParalisacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasParalisacoes/update`, request);
      const response = handleAxiosResponse<UpdateDiarioObrasParalisacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObraParalisacoes(request: DeleteDiarioObraParalisacoesRequest): Promise<DeleteDiarioObraParalisacoesResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObrasParalisacoes/delete", { data: request });

      const response = handleAxiosResponse<DeleteDiarioObraParalisacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Imagens

  async getAllListagemDiariosObrasImagens(request: GetAllDiarioObrasImagensRequest): Promise<GetAllDiarioObrasImagensResponse> {
    try {
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasImagens/listDiarioObrasImagens`, request);
      const response = handleAxiosResponse<GetAllDiarioObrasImagensResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createDiarioObraImagens(request: CreateDiarioObrasImagensRequest): Promise<CreateDiarioObrasImagensResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasImagens/create`, formData, options);
      const response = handleAxiosResponse<CreateDiarioObrasImagensResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateDiarioObraImagens(request: UpdateDiarioObrasImagensRequest): Promise<UpdateDiarioObrasImagensResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(`diarioObras/diarioObrasImagens/update`, formData, options);
      const response = handleAxiosResponse<UpdateDiarioObrasImagensResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteDiarioObraImagens(request: DeleteDiarioObraImagensRequest): Promise<DeleteDiarioObraImagensResponse> {
    try {
      const result = await axiosInstance({}).delete("/diarioObras/diarioObrasImagens/delete", { data: request });
      const response = handleAxiosResponse<DeleteDiarioObraImagensResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async downloadDiarioObraArquivoById(request: DownloadDiarioObraImagensRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({})
        .get(`/diarioObras/diarioObrasImagens/${request.idDiarioObrasImagens}/download`, {
          responseType: 'blob'
        });
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Principal
  async getAllListagemIndicadores(): Promise<GetAllDiarioObrasIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).get("/diarioObras/indicadores");
      const rawData = handleAxiosResponse<DiarioObrasIndicadores>(result);
      const response: GetAllDiarioObrasIndicadoresResponse = {
        indicadores: rawData
      };
      return response;

    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion
}
